import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { PersonalizedContentApiClient } from '../../api-clients';
const {
  Provider,
  ...client
} = PersonalizedContentApiClient;
export const PersonalizedContentExtension = createModuleExtension({
  extensionName: 'personalizedContentExtension',
  Provider,
  SDK: {
    personalizedContentApiClient: client
  }
});
//# sourceMappingURL=personalized-content.extension.js.map